import type { CustomerListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import type { CustomerListItem } from '../customers.api';

interface CustomersTableProps {
  page: Page<CustomerListItem>;
  columns: TableColumnsType<CustomerListItem>;
  list: ListQueryControls<CustomerListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function CustomersTable({ page, columns, list, isRefreshing }: CustomersTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search name or KRA PIN" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingCustomers /> } : undefined}
        {...list.tableProps<CustomerListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingCustomers() {
  return <EmptyState icon={SearchX} title="No matching customers" description="No customers match this search or these filters." />;
}
